export const TIMELINE_HEIGHT_PX = 480;
export const SNAP_MINUTES = 15;
export const MS_PER_DAY = 24 * 60 * 60 * 1000;

export interface DayTimelineRequest {
  id: string;
  startDateTime: string | number;
  endDateTime: string | number;
  areas?: string[];
  requesterUserId?: string;
  reason?: string;
}

export function startOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function toEpochMs(value: string | number): number {
  if (typeof value === 'number') return value;
  const num = Number(value);
  if (!Number.isNaN(num)) return num;
  return Date.parse(value);
}

export function snapToQuarterHour(ms: number, day: Date): number {
  const dayStart = startOfDay(day).getTime();
  const maxMs = dayStart + MS_PER_DAY - SNAP_MINUTES * 60 * 1000;
  let minutes = (ms - dayStart) / (60 * 1000);
  minutes = Math.round(minutes / SNAP_MINUTES) * SNAP_MINUTES;
  minutes = Math.max(0, Math.min((MS_PER_DAY / 60000) - SNAP_MINUTES, minutes));
  return Math.min(dayStart + minutes * 60 * 1000, maxMs);
}

export function msToY(ms: number, day: Date): number {
  const dayStart = startOfDay(day).getTime();
  const ratio = (ms - dayStart) / MS_PER_DAY;
  return Math.max(0, Math.min(TIMELINE_HEIGHT_PX, ratio * TIMELINE_HEIGHT_PX));
}

export function yToMs(y: number, day: Date): number {
  const dayStart = startOfDay(day).getTime();
  const ratio = Math.max(0, Math.min(1, y / TIMELINE_HEIGHT_PX));
  return snapToQuarterHour(dayStart + ratio * MS_PER_DAY, day);
}

export function formatTime(ms: number): string {
  return new Date(ms).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function hourRateColor(hour: number): string {
  if (hour >= 18 || hour < 6) return '#f56565';
  if (hour >= 12 && hour < 18) return '#f6e05e';
  return '#68d391';
}

export function requestOnDay(request: DayTimelineRequest, day: Date): boolean {
  const dayStart = startOfDay(day).getTime();
  const dayEnd = dayStart + MS_PER_DAY;
  const start = toEpochMs(request.startDateTime);
  const end = toEpochMs(request.endDateTime);
  return end > dayStart && start < dayEnd;
}

export function clampRangeToDay(startMs: number, endMs: number, day: Date): { startMs: number; endMs: number } {
  const dayStart = startOfDay(day).getTime();
  const dayEnd = dayStart + MS_PER_DAY;
  let start = snapToQuarterHour(Math.max(startMs, dayStart), day);
  let end = snapToQuarterHour(Math.min(endMs, dayEnd), day);
  if (end <= start) {
    end = Math.min(start + SNAP_MINUTES * 60 * 1000, dayEnd);
  }
  return { startMs: start, endMs: end };
}
